export const fomratString = (role: string) => {
    return role
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

/**
 * Mask patient mobile number for display: show first 3 digits, then asterisks.
 * e.g. "7011733681" → "701*******"
 */
export function maskPhoneDisplay(phone: string | null | undefined): string {
  if (!phone) return '—';
  const digits = phone.replace(/\D/g, '');
  if (digits.length <= 3) return digits;
  return digits.slice(0, 3) + '*'.repeat(digits.length - 3);
}